import { render } from "./App.vue?vue&type=template&id=28f3f54a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=28f3f54a&lang=scss"

import exportComponent from "/Users/matthew/Documents/Vault/code/sal/hhkh/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__